import gql from 'graphql-tag';

export const GET_BRAZIL_BANKS = gql`
  query getBrazilBanks($input: GetBrazilBanksInput) {
    getBrazilBanks(input: $input) {
      id
      name
      code
    }
  }
`;

export type GetBrazilBanksResponse = {
  getBrazilBanks: {
    id: string;
    name: string;
    code: string;
  }[];
};

export type GetBrazilBanksVariables = {
  input: {
    name?: string;
    codes?: string[];
  };
};
